import { findIndex } from 'lodash/fp';
import { EDITOR } from 'constants/actionTypes';

const reduceIntegrations = (integrations = [], action) => {
  const { payload } = action;
  const index = findIndex({ payload });

  switch (action.type) {
    case EDITOR.INTEGRATIONS.DATA_RECEIVE:
      return [
        ...integrations.slice(0, index),
        payload,
        ...integrations.slice(index + 1),
      ];

    case EDITOR.INTEGRATIONS.DATA_FAILURE:
      return action.error;

    default:
      return integrations;
  }
};

export default reduceIntegrations;
